import Pane from 'components/Common/Pane'
import { getImageUrl } from 'lib/image/imageUtils'
import React from 'react'
import styled, { keyframes } from 'styled-components'

const Container = styled(Pane)`
  display: grid;
  grid-template: "backdrop" 1fr / 1fr;
  position: relative;
`

const FadeDuration = 8

const FadeInOutAnimation = keyframes`
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  `

const AnimatedBackground = styled.div`
  pointer-events: none;
  animation-name: ${FadeInOutAnimation};
  animation-duration: ${FadeDuration}s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  opacity: 0;
  grid-area: backdrop;
  background-image: url(${getImageUrl('0fknb6o0atr40ssr4si')});
`

interface Props {
  className?: string
}

function TripLandingAnimatedBackground(props: Props) {
  const { className } = props

  return <Container className={className} paletteType="inverse">
    <AnimatedBackground />
  </Container>
}

export default TripLandingAnimatedBackground
